import type { QueryClient } from '@tanstack/react-query';
import type { SystemEventResponse } from '../../types/event.types';
import type { EventHandlerMap } from './eventHandler';

export const applyEvent = (event: SystemEventResponse, queryClient: QueryClient, originId: string, registry: EventHandlerMap[]): void => {
    for (const handlers of registry) {
        handlers[event.eventType]?.(event, queryClient, originId);
    }
};
